import styled, {css} from 'styled-components'

export const StyledProductsSectionWrapper = styled.div(
    ({theme: {spacing, palette}}) => css`
        padding: ${spacing * 14}px;
        height: 100%;
        width: 100%;
        color: ${palette.primary[950]};
    `
)
export const StyledSectionTitle = styled.div(
    ({theme: {typography, spacing}}) => css`
        ${typography.displaySm};
        font-weight: 500;
        padding-bottom: ${spacing * 4}px;
    `
)

export const StyledHeader = styled.div`
    ${({theme: {spacing, palette}}) => css`
        background-color: ${palette.neutral[100]};
        border-radius: ${spacing * 2}px;
        display: grid;
        grid-template-columns: 180px 1fr 1fr 1fr 1fr;
        gap: ${spacing * 4}px;
        padding: ${spacing * 4}px;
        margin-bottom: ${spacing * 4}px;
    `}
`

export const StyledHeaderTitle = styled.h3`
    ${() => css`
        font-weight: 600;
    `}
`

export const StyledGroupTitle = styled.h3`
    ${({theme: {spacing}}) => css`
        font-weight: 600;
        padding: ${spacing * 4}px;
    `}
`

export const StyledGroupHeaderItem = styled.div`
    font-weight: 600;
    text-align: right;
`

export const StyledProductRow = styled.div`
    ${({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: 180px 1fr 1fr 1fr 1fr;
        gap: ${spacing * 4}px;
        padding: ${spacing * 4}px ${spacing * 4}px 0;
    `}
`

export const StyledProductName = styled.div`
    flex: 1;
`

export const StyledQuantity = styled.div`
    text-align: right;
`

export const StyledPrice = styled.div`
    ${() => css`
        text-align: right;
    `}
`
